/** 28.09 (ДК: «можно ещё сделать, чтобы было видно, зачем заблокировали время»). Причину
 *  при блокировке спрашивали всегда (BlockReasonPrompt), но нигде не показывали. */

/** Причина блока: колонка block_reason; у старых строк — комментарий «БЛОК · …». */
export function blockReasonOf(b: { blockReason?: string | null; comment?: string | null } | null | undefined): string {
  if (!b) return "";
  return String(b.blockReason || String(b.comment ?? "").replace(/^БЛОК · /, "")).trim();
}

/** UTC из базы («2026-09-28 12:43:00») → «28.09 17:43» по Оренбургу. */
export function fmtOrenAt(at: string | null | undefined): string {
  if (!at) return "";
  const t = Date.parse(at.includes("T") ? at : `${at.replace(" ", "T")}Z`);
  if (!Number.isFinite(t)) return "";
  const d = new Date(t + 5 * 3600000);
  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(d.getUTCDate())}.${p(d.getUTCMonth() + 1)} ${p(d.getUTCHours())}:${p(d.getUTCMinutes())}`;
}

/** Тост move-режима сетки на занятом слоте: у блока — зачем заблокировали. */
export function busySlotToast(data: { type?: string; blockReason?: string | null; comment?: string | null } | null | undefined): string {
  if (data?.type !== "block") return "Слот занят — выбери свободный";
  const r = blockReasonOf(data);
  return `Слот заблокирован${r ? `: ${r}` : ""} — выбери свободный`;
}

/** 12.10 (владелец: «таймслот фазмы на 19:00 заблокирован»): чем занят автоблок. Свой квест —
 *  окно уборки рядом с игрой в нестандартное время; связанный — игра соседней комнаты.
 *  Раньше и то и другое называлось «связанным квестом», и причина была не видна. */
export function autoBlockNote(ab: { questId: string; src: string; srcTime?: string }): string {
  const at = ab.srcTime ? ` ${ab.srcTime}` : "";
  return ab.src === ab.questId ? `Окно уборки: игра${at} этого квеста` : `Занято связанным квестом${at ? `: игра${at}` : ""}`;
}
